// External deps
import PropTypes from 'prop-types';
// Internal deps
import { Button } from 'ypf-pas-general-ui-components';
import { MdFilterAlt } from 'react-icons/md';

import NoWorkReports from '../NoWorkReports';
import InputCalendar from '../../Calendar/InputCalendar/InputCalendar';
import { formatFullDate, formatsEnum } from '../../../utils/formatUtils';
import {
  AttachedFilesPermissions,
  PositionLinePermissions
} from '../../MonthlyServiceRequest/RequestDetailTypes';
import useWorkReport from '../../../hooks/useWorkReport';
import { checkRol } from '../../../security';
import { notificador, proveedorNotificador } from '../../../security/constantsRols';
import ComponentWithTooltip from '../../ComponentWithTooltip/ComponentWithTooltip';
import colors from '../../../styles/colors.module.scss';
import { useFilterContext } from '../../../context/FilterDetailSDSContext';

import ButtonsView from './ButtonsView/ButtonsView';
import MonthlyView from './MonthlyView/MonthlyView';
import WeeklyView from './WeeklyView/WeeklyView';
import DailyView from './DailyView/DailyView';

const ViewOptionsContainer = (props) => {
  const {
    hasLines,
    changeInLines,
    setChangeInLines,
    newFetch,
    setNewFetch,
    endingDate,
    initialDate,
    positionLinesPermissions,
    typeOfUbication,
    idParteDiario,
    disabledEditStateCancelOrFinish,
    filesPermissions,
    isOyM,
    setShowFilters,
    notificaPP,
    asignationType,
    details
  } = props;

  const {
    calendarDate,
    firstDayWithReturnedLine,
    lastDayWithReturnedLine,
    devolutionDate,
    notifiedDate,
    // startDate,
    fetchLines,
    viewOptions,
    setViewOptions,
    firstDayOfWeek,
    lastDayOfWeek,
    isNotificationWindowOpen,
    forceWindow
  } = useWorkReport();

  const { filter } = useFilterContext();

  const isDailyView = viewOptions.includes('daily');
  const isWeeklyView = viewOptions.includes('weekly');
  const isMonthlyView = viewOptions.includes('monthly');

  const handleChangeDateCalendar = (valueDate) => {
    const formatedSelectedDay = formatFullDate(calendarDate, formatsEnum.FORMAT_DATE_2);
    const valueDateFormated = formatFullDate(valueDate, formatsEnum.FORMAT_DATE_2);

    // If the date does not change then do not fetch
    if (formatedSelectedDay !== valueDateFormated && forceWindow !== null)
      fetchLines(valueDateFormated, undefined, filter);
  };

  const handleGoFirstLastDay = (firstDay = false) => {
    if (firstDay) {
      fetchLines(firstDayWithReturnedLine, undefined, filter);
    } else {
      fetchLines(lastDayWithReturnedLine, undefined, filter);
    }
  };

  const isProviderOrNotifier = checkRol(proveedorNotificador) || checkRol(notificador);

  const colorCalendarMapper = () => {
    const datesWithQuantityNotified = notifiedDate
      ?.map((date) => ({
        color: devolutionDate?.includes(date) ? '#FF0000' : '#312b2bc7',
        date
      }))
      ?.concat(
        devolutionDate
          ?.filter((date) => !notifiedDate?.includes(date))
          ?.map((date) => ({ color: '#FF0000', date }))
      );

    return datesWithQuantityNotified;
  };

  const CalendarComponent = () => (
    <InputCalendar
      arrayDate={colorCalendarMapper()}
      colorCalendar={
        isNotificationWindowOpen ? colors.calendarOpenWindow : colors.calendarClosedWindow
      }
      firstDayOfWeek={firstDayOfWeek}
      handleChangeDate={(val) => handleChangeDateCalendar(val)}
      isMSDS
      lastDayOfWeek={lastDayOfWeek}
      maxDate={endingDate}
      minDate={initialDate}
      onClickFirstDay={() => handleGoFirstLastDay(true)}
      onClickLastDay={() => handleGoFirstLastDay()}
      selectDay={calendarDate}
      showNotification={!isOyM && isProviderOrNotifier}
      view={viewOptions}
    />
  );

  return (
    <>
      {hasLines ? (
        <>
          <div className="d-flex justify-content-between ">
            <div className="d-flex align-items-center gap-3">
              {checkRol(proveedorNotificador) && (
                <Button
                  className="button-filters"
                  color="primary"
                  icon={MdFilterAlt}
                  onClick={() => setShowFilters(true)}
                  sizeIcon="20px"
                  type="button"
                  variant="white"
                  widthButton="30px"
                >
                  Filtros
                </Button>
              )}
              <ButtonsView setViewOptions={setViewOptions} viewOptions={viewOptions} />
            </div>
            {!isOyM && !isNotificationWindowOpen && isDailyView ? (
              <ComponentWithTooltip tooltipText="Fecha fuera de la ventana de notificación">
                {CalendarComponent()}
              </ComponentWithTooltip>
            ) : (
              CalendarComponent()
            )}
          </div>
          {isDailyView && (
            <DailyView
              asignationType={asignationType}
              changeInLines={changeInLines}
              colorCalendar={
                isNotificationWindowOpen ? colors.calendarOpenWindow : colors.calendarClosedWindow
              }
              details={details}
              disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
              endingDate={endingDate}
              filesPermissions={filesPermissions}
              forceWindow={forceWindow}
              idParteDiario={idParteDiario}
              initialDate={initialDate}
              isNotificationWindowOpen={isNotificationWindowOpen}
              isOyM={isOyM}
              newFetch={newFetch}
              notificaPP={notificaPP}
              positionLinesPermissions={positionLinesPermissions}
              setChangeInLines={setChangeInLines}
              setNewFetch={setNewFetch}
              setShowFilters={setShowFilters}
              typeOfUbication={typeOfUbication}
            />
          )}

          {isWeeklyView && (
            <WeeklyView
              disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
              forceWindow={forceWindow}
              isOyM={isOyM}
              newFetch={newFetch}
              positionLinesPermissions={positionLinesPermissions}
              setNewFetch={setNewFetch}
              typeOfUbication={typeOfUbication}
            />
          )}
          {isMonthlyView && (
            <MonthlyView
              disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
              positionLinesPermissions={positionLinesPermissions}
              setNewFetch={setNewFetch}
            />
          )}
        </>
      ) : (
        <NoWorkReports />
      )}
    </>
  );
};

ViewOptionsContainer.propTypes = {
  details: PropTypes.shape({}),
  changeInLines: PropTypes.bool.isRequired,
  endingDate: PropTypes.string,
  hasLines: PropTypes.bool.isRequired,
  newFetch: PropTypes.bool.isRequired,
  positionLinesPermissions: PositionLinePermissions.isRequired,
  setChangeInLines: PropTypes.func,
  setNewFetch: PropTypes.func.isRequired,
  idParteDiario: PropTypes.number,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  typeOfUbication: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }).isRequired,
  filesPermissions: AttachedFilesPermissions,
  isOyM: PropTypes.bool,
  initialDate: PropTypes.string,
  setShowFilters: PropTypes.func,
  notificaPP: PropTypes.bool.isRequired,
  asignationType: PropTypes.number.isRequired
};

ViewOptionsContainer.defaultProps = {
  details: {},
  setChangeInLines: () => {
    /* empty */
  },
  endingDate: null,
  idParteDiario: null,
  filesPermissions: {
    visualize: false,
    write: false
  },
  isOyM: false,
  initialDate: null,
  setShowFilters: () => {}
};

export default ViewOptionsContainer;
